module.exports = __webpack_public_path__ + "img/edison_logo.f65270e3.png";